import { NavLink, Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/features/auth/store/auth-store";
import { cn } from "@/lib/utils";

const referenceTabs = [
  { label: "Overview", path: "/settings/reference", end: true },
  { label: "Notices", path: "/settings/reference/notices", end: false },
  { label: "Tax Forms", path: "/settings/reference/tax-forms", end: false },
  { label: "Standards", path: "/settings/reference/standards", end: false },
  { label: "Transaction Codes", path: "/settings/reference/transaction-codes", end: false },
  { label: "Transcript Types", path: "/settings/reference/transcript-types", end: false },
];

/**
 * Shell for the ops-only Settings → Reference Data area. Global reference data
 * is maintained by staff, so this gates the whole sub-tree on `is_staff` (the
 * backend independently enforces staff-only writes — this is UX, not the trust
 * boundary). Its own underline sub-nav mirrors `SettingsLayout`.
 */
export function ReferenceLayout() {
  const isStaff = useAuthStore((s) => !!s.user?.is_staff);

  if (!isStaff) {
    return <Navigate to="/profile" replace />;
  }

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Reference Data</h1>
        <p className="text-muted-foreground text-sm">
          Global IRS lookup data every workflow reads — maintained by ops, refreshed when the
          IRS republishes standards.
        </p>
      </div>
      <div className="bg-card -mx-6 overflow-x-auto border-b px-6">
        <div className="flex min-w-max items-center gap-6">
          {referenceTabs.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              end={tab.end}
              className={({ isActive }) =>
                cn(
                  "mt-1 border-b-2 pb-4 text-sm font-semibold transition-colors",
                  isActive
                    ? "border-primary text-primary"
                    : "text-muted-foreground hover:text-primary border-transparent",
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>
      <div>
        <Outlet />
      </div>
    </div>
  );
}
